<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'ConsultantContactCard',
  mixins: [baseMixin],
  props: {
    contact: { type: Object, required: true },
  },
}
</script>

<template>
  <v-alert
    :class="['rounded-xl text-left', 'custom-elevation', 'contact-card']"
  >
    <div :class="[isMediumOrHigher ? 'mr-auto' : '']">
      <div class="d-flex justify-space-between align-start">
        <div>
          <h2>
            {{ contact.name }}
          </h2>
          <p class="text-subtitle-2 text--secondary mb-3">
            {{ contact.clientName }}
          </p>
        </div>

        <v-chip
          color="rgba(255, 255, 255, 0.2)"
          link
          :class="['text-subtitle-2']"
          :href="`tel:${contact.phoneNumber}`"
        >
          <v-avatar left color="white">
            <v-icon small color="primary">mdi-phone</v-icon>
          </v-avatar>
          {{ contact.phoneNumber }}
        </v-chip>
      </div>
    </div>
  </v-alert>
</template>
